import { types } from 'mobx-state-tree';

const CheckoutSubmitType = {
  CONFIRM_ORDER: 'CONFIRM_ORDER',
  MOVE_TO_PAYMENT: 'MOVE_TO_PAYMENT',
};

export default CheckoutSubmitType;

export const CheckoutSubmitTypeType = types.enumeration(
  'CheckoutSubmitType',
  Object.values(CheckoutSubmitType)
);
